const SafetyFaqContent = [
  {
    title: 'How do we ensure driver safety?',
    info: [
      {
        pretext:
          'Our vehicles are fully insured, regularly serviced by certified mechanics, and come with complete service records. '
      },
      {
        pretext:
          'In case of any unexpected incidents, we have 24/7 roadside assistance and a clear reporting procedure. Our in-car technology keeps an eye on driving behavior to ensure a safe driving experience for all.'
      }
    ]
  },
  {
    title: 'COVID-19: What is Autzu doing to keep the vehicles safe?',
    info: [
      {
        pretext:
          'Autzu takes cleanliness seriously and has implemented extra measures, including antiviral solutions, to keep our vehicles hygienic. If we discover a potential virus exposure, we remove the vehicle for a thorough cleaning.'
      }
    ]
  },
  {
    title: 'COVID-19: What can you do to help keep our community safe?',
    info: [
      {
        text: {
          plaintext: 'Wash and sanitize your hands frequently.'
        }
      },
      {
        text: {
          plaintext:
            'Bring disinfectant wipes to clean the vehicle before and after use. Cleaning wipes are also available at the lot.'
        }
      },
      {
        text: {
          plaintext:
            'To be cautious, wear a mask while driving and keep windows open for ventilation at your discretion.'
        }
      },
      {
        text: {
          plaintext:
            "If you're feeling unwell or showing symptoms, please cancel your booking and stay home."
        }
      },
      {
        text: {
          plaintext:
            "If you become sick after your booking, let us know so we can isolate the vehicle and ensure it's thoroughly cleaned before rebooking."
        }
      }
    ]
  }
];

export default SafetyFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/SafetyFaqContent.js